import Modal from "@mui/material/Modal";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { globalConfig } from "../configuration/config";
import { linkActive } from "../store/reducers/linkSlice";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import {
  buildWidgetNewProjectAuthGateUrl,
  buildWidgetProjectUrl,
  defaultWidgetNewAuthGateBaseUrl,
  defaultWidgetNewMaterialAssignmentAuthGateBaseUrl,
} from "./widget-new-auth-gate";

export default function OpenNewLink() {
  const { t } = useTranslation();
  const [showAdditionalLinks, setShowAdditionalLinks] = React.useState(false);

  const linkOpen = useSelector((state) => state.link.open);
  const projectGuid = useSelector(
    (state) => state?.variant?.current?.projectGuid
  );
  const calculationGuid = useSelector(
    (state) => state?.variant?.current?.calculationGuid
  );
  const isGuidDispayType = useSelector(
    (state) => state?.guids?.guidDisplayType
  );
  const isCatalog = useSelector((state) => state?.project?.templateStatusOpen);
  const companyId = useSelector((state) => state?.project?.companyId);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(linkActive(false));
  };

  const handleRowClick = ({ href, onClick }) => {
    if (onClick) {
      onClick();
      return;
    }

    if (href === "") {
      return;
    }

    window.open(href, "_blank", "noopener,noreferrer");
  };

  const openWidgetModal = () => {
    if (typeof window.varwidget !== "undefined") {
      window.varwidget.showCalculation(calculationGuid);
    }
  };

  const widgetNewHref = buildWidgetNewProjectAuthGateUrl({
    baseUrl:
      globalConfig.config.common.widget_new_auth_gate ||
      defaultWidgetNewAuthGateBaseUrl,
    calculationGuid,
    companyId,
    projectGuid,
  });
  const widgetNewMaterialAssignmentPreviewHref = buildWidgetNewProjectAuthGateUrl({
    baseUrl:
      globalConfig.config.common.widget_new_material_assignment_auth_gate ||
      defaultWidgetNewMaterialAssignmentAuthGateBaseUrl,
    calculationGuid,
    companyId,
    projectGuid,
  });
  const widgetNewOldContourHref = buildWidgetProjectUrl({
    baseUrl: globalConfig.config.common.widget_new,
    calculationGuid,
    companyId,
    projectGuid,
  });
  const widgetOldHrefBase = buildWidgetProjectUrl({
    baseUrl: globalConfig.config.common.widget,
    calculationGuid,
    companyId,
    projectGuid,
  });
  const widgetOldHref = widgetOldHrefBase;
  const vercelNewHref = buildWidgetProjectUrl({
    baseUrl: globalConfig.config.common.vercel_new,
    calculationGuid,
    companyId,
    projectGuid,
  });
  const vercelOldHref = buildWidgetProjectUrl({
    baseUrl: globalConfig.config.common.vercel_old,
    calculationGuid,
    companyId,
    projectGuid,
  });
  const widgetPhotoVideoHref = buildWidgetProjectUrl({
    baseUrl: globalConfig.config.common.widget_photo_video,
    calculationGuid,
    companyId,
    projectGuid,
  });
  const remerHref = buildWidgetProjectUrl({
    baseUrl: globalConfig.config.common.remer,
    calculationGuid,
    companyId,
    projectGuid,
  });
  const veryOldVroomHref = `${
    globalConfig.config.common.vroom
  }?calculation=${calculationGuid}&project=${
    isGuidDispayType?.length > 0 ? isGuidDispayType : projectGuid
  }&room=${projectGuid}${calculationGuid}&isCatalog=${isCatalog}`;
  const additionalIconPath = showAdditionalLinks ? "M5 15l7-7 7 7" : "M19 9l-7 7-7-7";
  const linkRows = [
    {
      href: widgetNewHref,
      key: "new-vroom-new-contour",
      label: (
        <>
          {t("openNewLink.vroomPrefix")} (<strong>{t("openNewLink.newContour")}</strong>){" "}
          {t("openNewLink.button3dSuffix")}
        </>
      ),
    },
    {
      href: widgetNewOldContourHref,
      key: "new-vroom-old-contour",
      label: t("openNewLink.newVroomOldContour"),
    },
    {
      href: remerHref,
      key: "remer",
      label: t("openNewLink.remer"),
    },
    {
      href: widgetOldHref,
      key: "old-vroom",
      label: (
        <>
          {t("openNewLink.vroomPrefix")} (<strong>{t("openNewLink.widget")}</strong>)
        </>
      ),
    },
    {
      key: "old-vroom-modal",
      label: t("openNewLink.currentVroomModal"),
      onClick: openWidgetModal,
    },
    {
      href: veryOldVroomHref,
      key: "very-old-vroom",
      label: t("openNewLink.oldVroom"),
    },
  ];
  const additionalLinkRows = [
    {
      href: widgetNewMaterialAssignmentPreviewHref,
      key: "new-vroom-material-assignment-preview",
      label: t("openNewLink.newVroomMaterialAssignmentPreview"),
    },
    {
      href: widgetPhotoVideoHref,
      key: "new-vroom-photo-video",
      label: t("openNewLink.newVroomPhotoVideo"),
    },
    {
      href: vercelNewHref,
      key: "new-vroom-old-contour-vercel",
      label: t("openNewLink.newVroomVercel"),
    },
    {
      href: vercelOldHref,
      key: "old-vroom-vercel",
      label: t("openNewLink.oldVroomVercel"),
    },
  ];

  const body = (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 560,
        maxWidth: "calc(100vw - 32px)",
        bgcolor: "background.paper",
        borderRadius: 2,
        p: 3,
      }}
    >
      <div className="infoList--title">{t("openNewLink.title")}</div>
      <table
        style={{
          borderCollapse: "collapse",
          marginTop: "16px",
          width: "100%",
        }}
      >
        <tbody>
          {linkRows.map((row) => (
            <tr
              key={row.key}
              onClick={() => handleRowClick(row)}
              style={{
                borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                cursor: "pointer",
              }}
            >
              <td
                style={{
                  fontSize: "14px",
                  fontWeight: 600,
                  padding: "14px 0",
                }}
                colSpan={2}
              >
                {row.label}
              </td>
            </tr>
          ))}
          {showAdditionalLinks &&
            additionalLinkRows.map((row) => (
              <tr
                key={row.key}
                onClick={() => handleRowClick(row)}
                style={{
                  borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                  cursor: "pointer",
                }}
              >
                <td
                  style={{
                    color: "rgba(0, 0, 0, 0.72)",
                    fontSize: "14px",
                    fontWeight: 600,
                    padding: "14px 0",
                  }}
                  colSpan={2}
                >
                  {row.label}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <Button
        endIcon={
          <svg
            aria-hidden="true"
            fill="none"
            height="16"
            viewBox="0 0 24 24"
            width="16"
          >
            <path
              d={additionalIconPath}
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
            />
          </svg>
        }
        onClick={() => setShowAdditionalLinks((value) => !value)}
        size="small"
        sx={{
          color: "text.secondary",
          fontSize: "12px",
          mt: 1.5,
          px: 1.5,
          textTransform: "none",
        }}
        variant="outlined"
      >
        {t("openNewLink.additional")}
      </Button>
    </Box>
  );

  return (
    <div>
      <Modal
        open={linkOpen}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
}
